// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"UserSearch_searchWrapper__2T4gn","searchIcon":"UserSearch_searchIcon__kC-jq","searchInput":"UserSearch_searchInput__3z0Ow"};